import Resources from 'components/MapPage/CorporateViewTabs/Resources';

export const ResourcesFullPage = () => {
  return (
    <div className="ps-2 pe-2">
      <Resources />
    </div>
  );
};
